import {FileUploadType} from './file.type';

export const FileUploadTypeIcon = {
	[FileUploadType.AnyFile]: 'file',
	[FileUploadType.Document]: 'file-alt',
	[FileUploadType.Pdf]: 'file-pdf',
	[FileUploadType.Doc]: 'file-word',
	[FileUploadType.Docx]: 'file-word',
	[FileUploadType.Xls]: 'file-excel',
	[FileUploadType.Xlsx]: 'file-excel',
	[FileUploadType.Csv]: 'file-csv',
	[FileUploadType.Image]: 'file-image',
	[FileUploadType.Jpg]: 'file-image',
	[FileUploadType.Jpeg]: 'file-image',
	[FileUploadType.Png]: 'file-image',
	[FileUploadType.Gif]: 'file-image',
	[FileUploadType.Svg]: 'file-image',
} as const;
